import { StatusAPIResponse } from "@farcaster/auth-kit";
import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import { useFetcher } from "@remix-run/react";
import { useState } from "react";

import { getEthAddress, getUserId } from "~/session.server";
import { buildMetaTags } from "~/utils";

import { LoginOptions } from "../components/Lens/LoginOptions";
import { LoginPageImage } from "../components/LoginPageImage";
import { LoginPageMessage } from "../components/LoginPageMessage";
import { Web3Provider } from "../providers/Web3Provider";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const userId = await getUserId(request);

  if (userId) return redirect("/");

  const ethAddress = getEthAddress(request);

  return json({ ethAddress });
};

export const meta: MetaFunction = () => buildMetaTags({ routeName: "login" });

export default function LoginPage() {
  const [farcasterError, setFarcasterError] = useState<string>();
  const fetcher = useFetcher();
  const handleSuccess = async (res: StatusAPIResponse) => {
    fetcher.submit(
      { ...res },
      { method: "post", action: "/api/auth/farcaster" },
    );
  };

  if (fetcher.state === "submitting") {
    return <div>Signing in...</div>;
  }

  return (
    <Web3Provider>
      <div className="flex h-dvh w-full flex-col justify-end bg-black relative overflow-hidden gap-7 py-7 px-5">
        <LoginPageImage farcasterError={farcasterError} />
        <img
          src="/assets/poke-logo-short.svg"
          alt="poke logo"
          className="w-[120px]"
        />
        <LoginPageMessage farcasterError={farcasterError} />
        <LoginOptions
          onError={setFarcasterError}
          onFarcasterSuccess={handleSuccess}
        />
      </div>
    </Web3Provider>
  );
}
